export const feature = [
    {
        name: "低空服务",
        url: "server"
    },
    {
        name: "无人机装备",
        url: "equip"
    },
    {
        name: "行业应用",
        url: "application"
    }
]

export const adhibition = [
    {
        title: "低空 + 测绘",
        img: 'mapping',
        subtitle: "高效测绘、智建未来",
        content: [
            {
                caption: "高效率",
                matter: "2套设备，覆盖整个城区近100平方公里<br/>单架次即可获取数平方公里的实景三维原始数据；"
            },
            {
                caption: "高精度",
                matter: "RTK与PPK技术可实现厘米级卫星定位精度，采集的数据均自带精准时空属性，所产生的实景三维数据可保障高质量，满足时序化采集的硬性要求"
            },
            {
                caption: "高质量",
                matter: "支持3D高斯集群运算能力,可调用数台高性能计算节点，实现海量数据的快速处理。"
            }
        ]
    },
    {
        title: "低空 + 巡检",
        img: 'polling',
        subtitle: "智能巡检、高效精准",
        content: [
            {
                caption: "",
                matter: "低空 + 巡检的行业应用展现出高效、精准、适应性强的突出优势；"
            },
            {
                caption: "",
                matter: "借助低空飞行器，单架次即可完成数十公里线路的巡检任务，大幅提升作业效率，相较传统人工巡检节省数倍时间；"
            },
            {
                caption: "",
                matter: "搭载高精度定位与成像设备，可实现毫米级缺陷识别，精准捕捉线路隐患，为故障排查提供可靠数据支持；"
            },
            {
                caption: "",
                matter: "同时具备良好的环境适应性，无论是复杂地形、恶劣天气还是高危区域，都能稳定作业，有效保障巡检工作的全面性与安全性。"
            }
        ]
    },
    {
        title: "低空 + 消防",
        img: 'firecontrol',
        subtitle: "消除隐患、预防灾患",
        content: [
            {
                caption: "- 快速寻找失联人员",
                matter: ""
            },
            {
                caption: "- 快速照明",
                matter: ""
            },
            {
                caption: "- 全天候待命",
                matter: ""
            },
            {
                caption: "",
                matter: "覆盖全城的无人机组网系统可快速到达应急现场，实时为多级指挥员更快捷地获取现场咨询，为救灾争取到宝贵的时间，让救援工作快速有效地进行。"
            }
        ]
    },
    {
        title: "低空 + 住建",
        img: 'housing',
        subtitle: "智慧住建、精准赋能",
        content: [
            {
                caption: "- 工程变化检测",
                matter: ""
            },
            {
                caption: "- 基坑位移检测",
                matter: ""
            },
            {
                caption: "",
                matter: "通过无人机搭载的多功能载荷对工程进展及质量进行检测,同时可利用高分贝喊话器对工程人员进行安全管理。"
            }
        ]
    },
    {
        title: "低空 + 安防",
        img: 'security',
        subtitle: "立体安防、全域掌控",
        content: [
            {
                caption: "- AI目标识别拍摄",
                matter: ""
            },
            {
                caption: "- 全自主无人化",
                matter: ""
            },
            {
                caption: "- 智能分析上报",
                matter: ""
            },
            {
                caption: "",
                matter: "可实现全天候、高频常态空中巡查，有效补充传统监控盲区减轻巡逻警员劳动强度和劳动时间，应急突发时间迅速加快突发事件的响应速度。"
            }
        ]
    }
]